import Vue from "vue";

const state = {
  data: {},
};

const actions = {
  addJobId: async ({ state, dispatch }, jobId) => {
    const year = new Date().getFullYear();

    if (state.data[year - 1]) {
      // Delete last years data
      delete state.data[year - 1];
    }

    if (!state.data[year]) {
      state.data[year] = [jobId];
      await dispatch("recordJobView", jobId);
      return;
    }

    if (!state.data[year].includes(jobId)) {
      state.data[year].push(jobId);
      await dispatch("recordJobView", jobId);
    }
  },

  // eslint-disable-next-line no-unused-vars
  recordJobView: async ({ state }, jobId) => {
    await Vue.http.post("/job-view", { job_id: jobId });
  },
};

export default {
  namespaced: true,
  state,
  actions,
};
